import './job-count.css';
import CountUp from 'react-countup';
import { useInView } from 'react-intersection-observer';

const JobCount = () => {
    const { ref, inView } = useInView({
        triggerOnce: true, // Ensures the animation runs only once
    });

    return (
        <div className="job-count-wrapper">
            <div className="job-count" ref={ref}>
                <div className="jobs">
                    <p>{inView && <CountUp start={0} end={1050} duration={2} />}+<br /> <span className='job-type'>GC<br/> JOBS</span></p>
                </div>
                <div className='line'></div>
                <div className="jobs">
                    <p>{inView && <CountUp start={0} end={975} duration={2} />}+<br /> <span className='job-type'>SP<br/> JOBS</span></p>
                </div>
                <div className='line'></div>
                <div className="jobs">
                    <p>{inView && <CountUp start={0} end={965} duration={2} />}+<br /> <span className='job-type'>SPECIAL<br/> PROJECTS</span></p>
                </div>
            </div>
            <div>
                <h2>Since 2015 And Counting...</h2>
            </div>
        </div>
    );
};

export default JobCount;